<div class="border-card border-0 px-4 py-1">
  <div class="row mt-3">
    <div v-for="card in status_cards" :key="card.title" class="col-md-4 mb-3">
      <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
  <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
    <!-- Icon -->
    <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
      <i :class="[card.icon, 'fa-lg', 'text-primary-blue']"></i>
    </div>

    <!-- Text -->
    <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
      <p class="mb-1 text-xs text-white">{{ card.title }}</p>
      <p class="m-0 fw-bold text-white">{{ card.count }}</p>
    </div>
  </div>
</div>

    </div>
  </div>

  <div v-if="is_loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading leads...</p>
  </div>

  <div v-show="selected_status && !is_loading" class="card rounded-lg p-0 mt-3 shadow border table-border-color">
    <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center pb-0 rounded-lg">
      <p class="mb-0">
        {{ status_cards.find(card => card.type === selected_status)?.title || 'Leads' }}
      </p>
    </div>
    <div class="card-body p-3">
      <div class="table-responsive text-xs">
        <table id="leads_table" class="table table-hover">
          <thead class="custom-header">
            <tr>
              <th v-for="header in table_headers" :key="header" class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="lead in filtered_leads" :key="lead.id">
              <td class="text-xxs text-start">{{ lead['Lead ID'] }}</td>
              <td class="text-xxs text-start">{{ lead.Name }}</td>
              <td class="text-xxs text-start">{{ lead.Email }}</td>
              <td class="text-xxs text-start">{{ lead.Phone }}</td>
              <td class="text-xxs text-start">{{ lead['Date Created'] }}</td>
              <td class="text-xxs text-start">
                <span class="text-xxs" :class="{
                  'text-dark': lead.Status === 'in-progress',
                  'bg-success': lead.Status === 'submitted',
                  'bg-danger': lead.Status === 'awaiting-verification',
                  'bg-info': lead.Status === 'approved',
                  'bg-secondary': lead.Status === 'closed'
                }">
                  {{ lead.Status }}
                </span>
              </td>
              <td class="text-xxs text-start">
                <div class="d-flex align-items-center gap-2">
                  <router-link
                    :to="{ name: 'leads_responses', query: { lead_id: lead['Lead ID'] } }"
                    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                  >
                    View
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <AICampusFooter />
</div>
